// react imports
import React, { useRef, useState } from "react";

// primereact imports
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { InputText } from "primereact/inputtext";

// import custom components
import ActionMenu from "../../common/action-menu/ActionMenu";
import AffectedPersonsDialog from "./affected-persons-dialog/AffectedPersonsDialog";

// data imports
import { PAGINATOR_TEMPLATE } from '../../../apis/constants';
import { AFFECTED_PERSONS } from '../../../apis/sampleData';


const emptyAffectedPerson = { name: '' };


const AffectedPersonsPage = () => {
  // new institution dialog state
  const [newAffectedPersonDialogVisible, setNewAffectedPersonDialogVisible] = useState(false);

  // edit institution dialog states
  const [editAffectedPersonDialogVisible, setEditAffectedPersonDialogVisible] = useState(false);
  const [affectedPerson, setAffectedPerson] = useState(emptyAffectedPerson);

  const [searchText, setSearchText] = useState('');

  // events
  const getAffectedPersonActionClickHandler = (name) => {
    return (actionName) => {
      switch (actionName) {
        case 'Edit':
          console.log(AFFECTED_PERSONS.find(ap => ap.name === name));
          setAffectedPerson(AFFECTED_PERSONS.find(ap => ap.name === name));
          setEditAffectedPersonDialogVisible(true);
          break;
        case 'Delete':
          confirmDialog({
            message: `Are you sure you want to delete ${name}?`,
            header: 'Delete Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => { console.log('Deleted'); },
            reject: () => { }
          });
          break;
        default:
          break;
      }
    };
  };

  // templates
  const getActionMenuTemplate = rowData => {
    const actions = [
      { name: 'Edit', iconClass: "las la-edit" },
      { name: 'Delete', iconClass: "las la-trash" }
    ];

    return (
      <ActionMenu
        actions={actions}
        actionSelected={getAffectedPersonActionClickHandler(rowData.name)}
      />
    );
  };

  // refs
  const searchRef = useRef();


  const filteredAffectedPersons = AFFECTED_PERSONS.filter(ap => {
    return ap.name.toLowerCase().includes(searchText);
  });


  return (
    <div className="settings--tab-content affected-persons">
      {/*<Editor style={{ height: '320px' }} placeholder="Additional information on implementation progress" />*/}

      <div className="settings--title-bar">
        <h1>Institutions</h1>
        <div className="settings--buttons">

          <div className="p-inputgroup search-inputgroup">
            <label className="p-inputgroup-addon" htmlFor="search-affected-person">
              <i className="las la-search"></i>
            </label>
            <InputText
              placeholder="Search Affected Person"
              type="text"
              id="search-affected-person"
              ref={searchRef}
              onChange={e => setSearchText(e.target.value)}
            />
            {/* <Button type="button" onClick={e => console.log(searchRef)}>
              <i className="las la-arrow-right"></i>
            </Button> */}
          </div>
          <Button
            icon="las la-plus-circle"
            label="New Affected Person"
            className="p-button-text"
            onClick={() => setNewAffectedPersonDialogVisible(true)}
          />
        </div>
      </div>

      <AffectedPersonsDialog
        affectedPerson={emptyAffectedPerson}
        dialogVisible={newAffectedPersonDialogVisible}
        saveButtonLabel="Create"
        dialogHeader="NEW AFFECTED PERSON"
        onClose={() => setNewAffectedPersonDialogVisible(false)}
        onSave={(name) => { setNewAffectedPersonDialogVisible(false); console.log(name); }}
      />

      <AffectedPersonsDialog
        affectedPerson={affectedPerson}
        dialogVisible={editAffectedPersonDialogVisible}
        saveButtonLabel="Save"
        dialogHeader="EDIT AFFECTED PERSON"
        onClose={() => setEditAffectedPersonDialogVisible(false)}
        onSave={(name) => { setEditAffectedPersonDialogVisible(false); console.log(name); }}
      />

      <DataTable
        value={filteredAffectedPersons}
        paginator
        paginatorTemplate={PAGINATOR_TEMPLATE}
        rows={10}
        sortField="name"
        sortOrder={1}
      >
        <Column className="name" field="name" header="Name" sortable></Column>
        <Column className="actions" header="Actions" body={getActionMenuTemplate}></Column>
      </DataTable>
    </div >
  );
};

export default AffectedPersonsPage;